import { Component, inject, Input } from '@angular/core';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { PaymentsService } from '@modules/universal-billing/accounting/payments/payments.service';
import { DatePipe, NgForOf, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Table } from '@primeng/table';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';
import { SharedModule } from '@primeng/api';
import { ModalClose } from '@shared/services/modal/modal.enum';

@Component({
  selector: 'app-resident-payments',
  standalone: true,
  imports: [
    DatePipe,
    NgForOf,
    NgIf,
    TranslatePipe,
    Table,
    SharedModule
  ],
  templateUrl: './resident-payments.component.html',
  styleUrl: './resident-payments.component.scss'
})
export class ResidentPaymentsComponent extends BasicTableComponent<any> {
  @Input() residentId: number;
  service = inject(PaymentsService);
  addQueryToUrl = false;
  getAll(params: any): Observable<PageResult<any>> {
    params.residentId = this.residentId;
    return super.getAll(params);
  }
  onAdd() {
    this.modalService.open({
      component: this.service.formComponent,
      title: this.translateService.instant('ADD_PAYMENT'),
      componentOptions: {
        _defaultService: this.service,
        residentId: this.residentId
      },
      modalOptions: this.service?.formModalOptions ?? {}
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.loadData();
      }
    })
  }

  onEdit(data: any) {
    this.modalService.open({
      component: this.service.formComponent,
      title: this.translateService.instant('EDIT_PAYMENT'),
      componentOptions: {
        selectedRow: data,
        residentId: this.residentId,
        isEdit: true,
        _defaultService: this.service
      },
      modalOptions: this.service?.formModalOptions ?? {}
    }).then((res) => {
      if (res == ModalClose.SUCCESS) {
        this.loadData();
      }
    }).catch((err) => {})
  }
}
